import { useRouter } from 'next/navigation';
import { Badge } from '@kcd/design-system';

import {
  CLAIMS_ROUTER,
  MYPAGE_ROUTER,
  OFFERS_ROUTER,
} from '~/constants/router';
import { useMyInquiryCount } from '~/domains/products/queries';

import { MypageCell } from './MypageCell';

export function MyPageNavigation() {
  const router = useRouter();

  const inquiryCount = useMyInquiryCount();

  return (
    <section className="px-20">
      <MypageCell
        title="최근 본 상품"
        onClick={() => router.push(OFFERS_ROUTER.recentlyViewed)}
      />
      <MypageCell
        title="교환/반품 조회"
        onClick={() => router.push(CLAIMS_ROUTER.root)}
      />
      <MypageCell
        title={
          <>
            상품문의
            {inquiryCount > 0 && (
              <Badge className="ml-8" type="number" text={inquiryCount} />
            )}
          </>
        }
        onClick={() => router.push(MYPAGE_ROUTER.inquiry)}
      />
      <MypageCell
        title="환불계좌 관리"
        onClick={() => router.push(MYPAGE_ROUTER.refundAccount)}
      />
    </section>
  );
}
